import { IDataWithLocalizedDescription } from '../../contracts/localized-data.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class LocalizedDescriptionComponent extends Component implements IDataWithLocalizedDescription {
  static readonly TYPE_ID: string = 'e5cb37e2511a4748a4986c95c673c441';

  constructor(
    public readonly descriptions: LocalizedString,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return LocalizedDescriptionComponent.TYPE_ID;
  }

  static empty(): LocalizedDescriptionComponent {
    return new LocalizedDescriptionComponent(LocalizedString.empty());
  }

  static fromMap(context: SerializationContext, map: SerializedData): LocalizedDescriptionComponent {
    return new LocalizedDescriptionComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'descriptions')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'descriptions': context.toData(this.descriptions),
    };
  }

  clone(): this {
    return new LocalizedDescriptionComponent(
        this.descriptions.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.descriptions, this.descriptions);
  }
}

export class LocalizedDescriptionComponentBuilder extends DataModelBuilder<LocalizedDescriptionComponent> {
  build(context: SerializationContext, map: SerializedData): LocalizedDescriptionComponent {
    return LocalizedDescriptionComponent.fromMap(context, map);
  }
}
